<template>
  <v-app>

    <v-main >

      <v-container v-bind:style="stylePagina">
        <v-alert
            :value="alerterror"
            color="error"
            dark
            dismissible
            border="top"
            transition="scale-transition"
        >
          {{error}}
        </v-alert>
        <v-row v-if="valida" align="center" justify="center">
          <v-col>
            <v-row  v-if="existe" justify="center" align="center">
              <v-col>
                <v-row v-if="usado" justify="center" align="center">
                  <v-col  cols="10" sm="10" lg="9" md="9"  v-bind:style="styleCardCodigo">
                    <v-row justify="center" align="center">
                      <v-col cols="12" lg="6" >

                      </v-col>
                      <v-col cols="12" lg="5" >
                        <v-card outlined :color="colorCard">
                          <v-card-title>
                            Código Usado
                          </v-card-title>
                          <v-card-text>
      <p>Este Código ya fue utilizado</p>
                          </v-card-text>
                        </v-card></v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row v-else justify="center" align="center">
                  <div v-if="soloInvitado" style="width: 100%">
                    <v-row justify="center" align="center" justify-lg="end" align-lg="end">
                      <v-col  cols="8" sm="8" lg="9" md="9" style="overflow: hidden;height: 100%;">
                      <div v-bind:style="styleBox">
                        <v-row justify="center" align="center" justify-lg="end" align-lg="end" style="width: 100%;">
                        <v-col lg="6" md="6" cols="12" sm="12">
                          <div style="height: 150px; width: 100%;" class="hidden-lg-only" />
                        </v-col>
                        <v-col lg="7" md="6" cols="10" sm="12">
                        <v-row  justify="center" align="center">
                        <v-col lg="5" md="6" cols="10" sm="6">
                          <v-text-field v-model="form.nombre" :counter="50" :rules="nameRules"  :color="styleColorLetra.color"  label="Nombre" required ></v-text-field>
                        </v-col>
                        <v-col lg="5" md="5" cols="10" sm="6">
                          <v-text-field v-model="form.apellidoPaterno" :counter="100"  :color="styleColorLetra.color" :rules="apellidosRules"  label="Apellido Paterno" required ></v-text-field>
                        </v-col>
                        <v-col lg="5" md="5" cols="10" sm="6">
                          <v-text-field v-model="form.email"  type="email" :counter="150"  :color="styleColorLetra.color" :rules="emailRules" label="Email" required></v-text-field>
                        </v-col>
                        <v-col  cols="10" lg="5" sm="6" md="5">
                          <v-autocomplete
                              v-model="form.tipoDocumento"
                              :items="tiposdoc"
                              item-text="tipoDocumento"
                              :rules="[v => !!v || 'Tipo de Documento es requerido']"
                              return-object

                              :color="styleColorLetra.color"
                              required
                              label="Tipo de Documento">

                          </v-autocomplete>
                        </v-col>
                        <v-col cols="10" lg="5" sm="6" md="5">
                          <v-text-field v-model="form.dni"  :color="styleColorLetra.color" label="Numero de Documento" :rules="dniRules" :counter="100" required></v-text-field>
                        </v-col>

                        </v-row>
                      <v-row justify="center" align="center" >
                        <v-col cols="12">
                          <v-alert
                              :value="alerterrorinvitado"
                              color="error"
                              dark
                              dismissible
                              border="top"
                              transition="scale-transition"
                          >
                            {{error}}
                          </v-alert>
                        </v-col>
                        <v-col md="5" lg="5" cols="5" sm="6" >

                          <v-btn rounded :disabled="!valid" @click="registerinvitado" class="primary">Solicitar</v-btn>

                        </v-col>
                        <v-col md="5" lg="5" cols="5" sm="6" >
                          <v-btn rounded @click="volver" class="error">Volver</v-btn>
                        </v-col>
                      </v-row> </v-col>
                        </v-row>
                      </div>
                    </v-col>
                    </v-row>
                  </div>
                  <div v-else style="width: 100%;     align-items: center!important;justify-content: center!important;">
              <v-col v-if="conectado" cols="12" sm="12" lg="9" md="9">
                <v-row justify="center" align="center">
                  <v-col cols="12" lg="10" md="10" >
                    <center><v-img width="270px" :src="negocio.logo270"></v-img></center>
                  </v-col>
                </v-row>
                <v-row justify="center" align="center">
                  <v-col cols="12" lg="12" >
                <v-card>
                  <v-card-title>
                    Validación Código
                  </v-card-title>
                  <v-card-text>
                    <v-row justify="center" align="center">
                      <v-col>
                        <p>QR Asignado con Éxito.</p>
                        <p><v-btn @click="gosotorgaqr">Ver QR</v-btn></p>

                      </v-col>
                    </v-row>
                    <v-row>
                    <v-col>
                      <p>Lista de QR's</p>
                      <p>También puedes ir a tu lista de QR's y bajarlo a tu wallet</p>
                      <p><v-btn :to="{name : 'misqrs'}">LISTA QR's</v-btn></p>
                      </v-col>
                    </v-row>

                  </v-card-text>
                </v-card></v-col>
                </v-row>
              </v-col>
              <v-col v-else cols="8" sm="8" lg="9" md="9" style="overflow: hidden;height: 100%;">
                <div v-bind:style="styleBox">
                <v-row justify="center" align="center">
                  <v-col cols="9" sm="9" lg="10" md="10" >
                    <center><v-img width="270px" :src="negocio.logo270"></v-img></center>
                  </v-col>
                </v-row>
                <v-row justify="center" align="center">
                <v-col cols="9" sm="9" lg="10" md="10" >
                <v-card outlined color="transparent">
                  <v-card-title v-bind:style="styleColorLetra">
                    <span v-bind:style="styleColorLetra"> Código {{codigoUnico}} es Válido para&nbsp; <strong>{{codigo.listaDetalleFiestaMaster.nombreActo}}</strong></span>
                  </v-card-title>
                  <v-card-text >
                    <div v-if="!existepersona">

                        <v-row justify="center" align="center">
                          <v-col v-if="normal" lg="9" md="9" cols="12" sm="12">
                            <v-row justify="center" align="center">
                              <v-col lg="9" md="9" cols="12" sm="12">
                                <ul>
                                  <li v-bind:style="styleColorLetra">Si eres nuevo Registrate, si ya tienes una cuenta con nosotros ingresa con Email.</li>
                                  <li v-if="browser" v-bind:style="styleColorLetra">Puedes igualmente ingresar directamente con Google o Apple, sin necesidad de registrarte.</li>
                                  <li v-else v-bind:style="styleColorLetra">Ingresaste por un browser interno de Instagram o algún otra app, para ingresar con Google o Apple te recomendamos abrir Chrome o Safari</li>
                                  <li v-bind:style="styleColorLetra">Sino deseas registrarte puedes entrar como invitado.</li>

                                </ul>                              </v-col>
                              <v-col lg="12" md="12" cols="12" v-bind:style="styleColorLetra">Al registrarse está aceptando nuestros <a href="https://tunay.app/terminos" target="_blank">Terminos y Condiciones</a> y <a href="https://tunay.app/politicas" target="_blank">Políticas de Privacidad</a></v-col>
                            </v-row>
                            <v-row v-if="browser" justify="center" align="center">
                              <v-col cols="10" lg="8" md="8">
                                <v-btn rounded width="100%" style="background: #4F86EC;" @click="signingoogle">
                                  <v-icon>fab fa-google</v-icon> &nbsp;Ingresa con Google
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-row v-if="browser" justify="center" align="center">
                            <v-col cols="10" lg="8" md="8">
                                <v-btn rounded width="100%" style="background: #E0E5FA; color: black;" @click="signinapple">
                                  <v-icon>fab fa-apple</v-icon> &nbsp;Ingresa con Apple
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-row justify="center" align="center">
                              <v-col cols="10" lg="8" md="8">
                                <v-btn rounded width="100%" style="background: #FFFFFF; color: black;" @click="signinemail">
                                  <v-icon>fas fa-envelope</v-icon> &nbsp;Ingresa con Email
                                </v-btn>
                              </v-col>
                            </v-row>
                            <v-row justify="center" align="center">
                              <v-col cols="10" lg="3" md="3" v-bind:style="styleColorLetra">
                                ¿Eres nuevo?
                              </v-col>
                            </v-row>
                            <v-row justify="center" align="center">
                              <v-col cols="10" lg="8" md="8">
                                <v-btn rounded width="100%" style="background: cornflowerblue; color: black;" @click="registeremail">
                                  <v-icon>fas fa-envelope</v-icon> &nbsp;Registrate con Email
                                </v-btn>
                              </v-col>
                            </v-row>

                            <v-row justify="center" align="center">
                               <v-col cols="10" lg="8" md="8">
                                 No quieres Registrarte te enviamos tu QR a tu email
                               </v-col>
                             </v-row>
                            <v-row justify="center" align="center">
                               <v-col cols="10" lg="8" md="8">
                                 <v-btn rounded width="100%" style="background: green; color: black;" @click="invitadoemail">
                                   <v-icon>fas fa-user-ninja</v-icon> &nbsp;Invitado
                                 </v-btn>
                               </v-col>
                             </v-row>
                          </v-col>
                          <v-col v-if="registro" lg="9" md="9" cols="12" sm="12">
                            <v-form
                                ref="form"
                                v-model="valid"
                                lazy-validation
                            >
                            <v-row>
                              <v-col lg="12" md="12" cols="12" sm="12">
                                <h2>Registrarse <strong  style="color: red;">(SI NO TIENE CUENTA INGRESE SUS DATOS)</strong></h2>
                              </v-col>
                              <v-col lg="6" md="6" cols="12" sm="6">
                                <v-text-field v-model="form.nombre" :counter="50" :rules="nameRules"  label="Nombre" required ></v-text-field>
                              </v-col>
                              <v-col lg="6" md="6" cols="12" sm="6">
                                <v-text-field v-model="form.apellidoPaterno" :counter="100" :rules="apellidosRules"  label="Apellido Paterno" required ></v-text-field>
                              </v-col>
                              <v-col lg="6" md="6" cols="12" sm="6">
                                <v-text-field v-model="form.email"  type="email" :counter="150" :rules="emailRules" label="Email" required></v-text-field>
                              </v-col>
                              <v-col  cols="12" lg="6" sm="6" md="4">
                                <v-autocomplete
                                    v-model="form.tipoDocumento"
                                    :items="tiposdoc"
                                    item-text="tipoDocumento"
                                    :rules="[v => !!v || 'Tipo de Documento es requerido']"
                                    return-object
                                    required
                                    label="Tipo de Documento">

                                </v-autocomplete>
                              </v-col>
                              <v-col cols="12" lg="6" sm="6" md="4">
                                <v-text-field v-model="form.dni" label="Numero de Documento" :rules="dniRules" :counter="100" required></v-text-field>
                              </v-col>






                              <v-col lg="6" md="6" cols="12" sm="6">
                                <v-text-field v-model="password2" type="password" label="Password" required></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row justify="center" align="center" >
                              <v-col md="6" lg="6" cols="5" sm="6" >
                                <v-alert
                                    :value="alerterrorregister"
                                    color="error"
                                    dark
                                    dismissible
                                    border="top"
                                    transition="scale-transition"
                                >
                                  {{error}}
                                </v-alert>
                                <v-btn rounded :disabled="!valid" @click="register" class="primary">Registrarse</v-btn>

                              </v-col>
                              <v-col md="6" lg="6" cols="5" sm="6" >
                                <v-btn rounded @click="volver" class="error">Volver</v-btn>
                              </v-col>
                            </v-row>
                            </v-form>
                          </v-col>
                          <v-col v-if="login" lg="9" md="9" cols="12" sm="12">
                            <v-row>
                              <v-col lg="12" md="12" cols="12" sm="12">
                                <h2>Conectarse <strong  style="color: red;">( Si es que ya tiene cuenta)</strong></h2>
                              </v-col>
                              <v-col lg="12" md="12" cols="12" sm="12">
                                <v-text-field v-model="email"  type="email" label="Email"></v-text-field>
                              </v-col>
                              <v-col lg="12" md="12" cols="12" sm="12">
                                <v-text-field v-model="password" type="password" label="Password"></v-text-field>
                              </v-col>
                            </v-row>
                            <v-row justify="center" align="center" >
                              <v-col md="6" lg="6" cols="5" sm="6">
                                <v-btn rounded @click="submit" class="primary">Login</v-btn>
                              </v-col>
                              <v-col md="6" lg="6" cols="5" sm="6" >
                                <v-btn rounded @click="volver" class="error">Volver</v-btn>
                              </v-col>
                            </v-row>

                          </v-col>
                          <v-col v-if="invitado" lg="9" md="9" cols="12" sm="12">
                            <v-row>
                              <v-col lg="12" md="12" cols="12" sm="12">
                                <h2>Invitado <strong  style="color: red;">(Revise muy bien su email al ingresarlo, si algún dia decide tener una cuenta con nosotros los datos de sus QR's pasados aparecerán)</strong></h2>
                              </v-col>
                              <v-col lg="8" md="6" cols="12" sm="6">
                                <v-text-field v-model="form.nombre" :counter="50" :rules="nameRules"  label="Nombre" required ></v-text-field>
                              </v-col>
                              <v-col lg="8" md="6" cols="12" sm="6">
                                <v-text-field v-model="form.apellidoPaterno" :counter="100" :rules="apellidosRules"  label="Apellido Paterno" required ></v-text-field>
                              </v-col>
                              <v-col lg="6" md="6" cols="12" sm="6">
                                <v-text-field v-model="form.email"  type="email" :counter="150" :rules="emailRules" label="Email" required></v-text-field>
                              </v-col>
                              <v-col  cols="12" lg="6" sm="6" md="4">
                                <v-autocomplete
                                    v-model="form.tipoDocumento"
                                    :items="tiposdoc"
                                    item-text="tipoDocumento"
                                    :rules="[v => !!v || 'Tipo de Documento es requerido']"
                                    return-object
                                    required
                                    label="Tipo de Documento">

                                </v-autocomplete>
                              </v-col>
                              <v-col cols="12" lg="6" sm="6" md="4">
                                <v-text-field v-model="form.dni" label="Numero de Documento" :rules="dniRules" :counter="100" required></v-text-field>
                              </v-col>

                            </v-row>
                            <v-row justify="center" align="center" >
                              <v-col md="6" lg="6" cols="5" sm="6" >
                                <v-alert
                                    :value="alerterrorinvitado"
                                    color="error"
                                    dark
                                    dismissible
                                    border="top"
                                    transition="scale-transition"
                                >
                                  {{error}}
                                </v-alert>
                                <v-btn rounded :disabled="!valid" @click="registerinvitado" class="primary">Solicitar</v-btn>

                              </v-col>
                              <v-col md="6" lg="6" cols="5" sm="6" >
                                <v-btn rounded @click="volver" class="error">Volver</v-btn>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                    </div>
                  </v-card-text>
                </v-card></v-col>
                </v-row>
                </div>
              </v-col>
                  </div>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-else justify="center" align="center">
              <v-col  cols="10" sm="10" lg="9" md="9"  v-bind:style="styleCardCodigo">
                <v-row justify="center" align="center">
                  <v-col cols="12" lg="6" >
                  </v-col>
                </v-row>
                <v-row justify="center" align="center">
                  <v-col cols="12" lg="5" >
                    <v-card outlined :color="colorCard">
                  <v-card-title v-bind:style="styleColorLetra">Código Incorrecto</v-card-title>
                  <v-card-subtitle v-bind:style="styleColorLetra">El Código que ingreso no existe en nuestra base de datos, puede buscar de nuevo.</v-card-subtitle>
                  <v-card-text v-bind:style="styleColorLetra">
                    <v-row>
                      <v-col cols="12" md="12" lg="12">
                        <v-text-field rounded outlined :color="styleColorLetra.color" v-model="codigoUnico" label="Código"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="12" lg="12">
                        <v-btn class="primary" @click="traeCodigo">
                          <v-icon>
                            fas fa-qrcode
                          </v-icon>
                          Comprobar de nuevo</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-else justify="center" align="center">

            <v-col  cols="10" sm="10" lg="9" md="9"  v-bind:style="styleCardCodigo">
              <v-row justify="center" align="center">
                <v-col cols="12" lg="6" >
             </v-col>
                <v-col cols="12" lg="5"  >
              <v-card outlined :color="colorCard">
                <v-card-title></v-card-title>
                <v-card-subtitle style="text-align: center;"><span v-bind:style="styleColorLetra">Ingrese su Código</span></v-card-subtitle>
                <v-card-text>
                  <v-row justify="center" align="center">
                    <v-col cols="12" md="12" lg="12">
                      <v-text-field v-model="codigoUnico"  rounded label="Código"  outlined :color="styleColorLetra.color"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12" lg="12">
                      <center><v-btn class="blue" @click="traeCodigo">
                        <v-icon>
                          fas fa-qrcode
                        </v-icon>
                        Comprobar</v-btn></center>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card></v-col>
              </v-row>
            </v-col>

          </v-row></v-container>
    </v-main>
    <v-overlay :value="overlay">
      <v-img
          src="@/assets/loadtunay.gif"

      />
    </v-overlay>
  </v-app>
</template>
<script>


import {mapGetters} from "vuex";
import axios from "axios";
import store from "@/store";
import tipoentrjson from "@/assets/json/tipoentradas.json";
import tipopagjson from "@/assets/json/tipopagos.json";
import tipoevenjson from "@/assets/json/tipoeventos.json";
import tipomembrjson from "@/assets/json/tipomembresias.json";
import sexosjson from "@/assets/json/sexos.json";
import estadocarjson from "@/assets/json/estadocarnet.json";
import diasjson from "@/assets/json/dias.json";
import firebase from 'firebase/compat/app';
import moment from "moment-timezone";

export default {
  name: 'validaqr',
  title: 'Valida QR | Tunay Mi acceso de bolsillo',
  components: {

  },
  created () {
    this.$vuetify.theme.dark = true
  },
  data () {
    return {
      codigo: {},
      negocio:{},
      elflyer:'',
      email: '',
      valid: true,
      tiposdoc: [],
      distritos:[],
      usado:false,
      normal:true,
      soloInvitado: false,
      login:false,
      registro:false,
      invitado:false,
      rese:'',
      token:'',
      browser:false,
      styleBox:{
        color:'white',
        width: '100%',
        height: '550px',
        boxSizing: 'content-box',
        overflowY:'scroll',
        overflowX: 'hidden',
        paddingRight: '5%',
       marginTop: '2%'
      },
      colorCard:'white',
      Cardcolor:'black',
      stylePagina: {
        backgroundColor: 'black',
        color:'white',
        backgroundImage:'',
        backgroundSize: 'cover',
        height:"100%",

      },
      alerterrorregister:false,
      alerterrorinvitado:false,
      activePicker:null,
      nameRules: [
        v => !!v || 'Nombre es requerido',
        v => (v && v.length <= 50) || 'Nombre no mayor de 50 ',
      ],
      apellidosRules: [
        v => !!v || 'Apellido es requerido',
        v => (v && v.length <= 100) || 'Apellido no mayor de 100 ',
      ],
      dniRules: [
        v => !!v || 'Numero de Documento es requerido',
        v => (v && v.length <= 100) || 'Numero de Documento no mayor de 100 ',
      ],
      emailRules: [
        v => !!v || 'E-mail es requerido',
        v => (v && v.length <= 150) || 'E-mail no mayor de 150 ',
        v => /.+@.+\..+/.test(v) || 'E-mail debe ser valido',
      ],
      sexos: [{id:0,sexo:"Escoger Sexo"}, {id:1, sexo:"Masculino"}, {id:2, sexo:"Femenino"}],
      form: {
        nombre: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        dni : "",
        foto: "",
        email: "",
        paisNac:null,
        tipoDocumento: null,
        telefono:"",
        direccion:"",
        fechaNacimiento:new Date().toISOString().substr(0, 10),
        sexo:null,
        fotoDni:"",
        postalCode:"",
        distrito:null,
        createdAt:"",
        uidFirebase: "",
        isprofile: true,
        isfoto : false,
        isverified: false
      },
      styleCardCodigo:{
      marginTop:'15%'
      },
      styleColorLetra:{
        color: 'black'
      },
      existe: false,
      password:'',
      menu: false,
      mobile:false,
      fechamax:null,
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      alerterror:false,
      error:'',
      password2:'',
      idlistadetalle:0,
      tipo:0,
      codigoUnico:'',
      overlay:false,
      valida:false,
      existepersona: false
    }
  },
  mounted() {
    this.idnegocio = "vastion";
    this.fnBrowserDetect();
    this.damenegocio();
    let cantEs = document.documentElement.clientWidth;
    console.log(cantEs)
    if(cantEs<=450){
      this.mobile = true
      let heightss  = document.documentElement.clientHeight * 0.7;
      console.log(heightss)
      this.styleCardCodigo.marginTop = "250px"
      this.styleBox.marginTop= "25%"
      this.styleBox.height= heightss.toString()+"px"

    }
    this.fechamax =this.formatDatee(new Date(new Date().setFullYear(new Date().getFullYear() - 18)))
    this.date = this.fechamax
    this.form.fechaNacimiento = this.formatDatee(this.date);
    if(this.usuario.id>0){
      store.dispatch("conectarse")
      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
    }

  },
  watch: {
    date () {
      this.form.fechaNacimiento = this.formatDatee(this.date)
    },
    menu (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    },
  },
  methods:{

    fnBrowserDetect(){

      let userAgent = navigator.userAgent;

      if(userAgent.match(/chrome|chromium|crios/i)){
        this.rese = "chrome";
        this.browser = true;
      }else if(userAgent.match(/firefox|fxios/i)){
        this.rese = "firefox";
        this.browser = true;
      }  else if(userAgent.match(/safari/i)){
        this.rese = "safari";
        this.browser = true;
      }else if(userAgent.match(/opr\//i)){
        this.rese = "opera";
        this.browser = true;
      } else if(userAgent.match(/edg/i)){
        this.rese = "edge";
        this.browser = true;
      }else{
        this.rese="No browser detection";
        this.browser = false;
      }

    },

    registerinvitado(){
      var bodyFormData = new FormData();
      this.form.createdAt = null
      this.form.fechaNacimiento = null

      this.overlay = true
      bodyFormData.append('data',JSON.stringify(this.form));
      axios.post("personas/registrar/invitado",bodyFormData)
          .then(response => {
            let persona =  response.data
            var bodyFormData2 = new FormData();
            bodyFormData2.append('codigo', this.codigoUnico.trim());
            bodyFormData2.append('personaId', persona.id);
            axios
                .post('general/codigo/fiesta',bodyFormData2)
                .then((response)  => {
                  this.codigo = response.data;
                  this.overlay = false;
                  this.$router.push({name:"qrinvitado", params:{codigoUnico: this.codigoUnico.trim()}})
                })
                .catch((error)  => {
                  console.log(error);
                  this.overlay = false;
                });
          })

    },
    dametipodocumentos(){
      this.progr = true;
      axios
          .get('tiposdocumento/pais/'+this.negocio.ciudad.provincia.pais.id)
          .then(response => {
            this.tiposdoc = response.data;
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    damedistritos(){
      this.progr = true;
      axios
          .get('distritos/ciudad/'+this.negocio.ciudad.id)
          .then(response => {
            this.distritos = response.data;
          })
          .catch((error)  => {
            console.log(error);
          });
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    damenegocio(){
      this.overlay = true;

      axios
          .get('negocios/tag/'+this.idnegocio)
          .then(response => {
            this.negocio = response.data;
            this.soloInvitado = this.negocio.soloInvitacion
            if(this.mobile){
              this.stylePagina.backgroundImage = 'url(' + 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/IMG_2520.PNG' + ')'
            }else{
              this.stylePagina.backgroundImage = 'url('  + 'https://tunaydisenio.s3.sa-east-1.amazonaws.com/IMG_2521.PNG' + ')'

            }
            this.colorCard = this.negocio.qrCardBgColor
            this.Cardcolor  = 'white'
            this.stylePagina.backgroundColor = this.negocio.qrBgColor
            this.styleColorLetra.color = 'white'
            this.stylePagina.color = 'white'
            this.overlay=false
            this.dametipodocumentos();
            this.damedistritos();
          })
          .catch((error)  => {
            this.overlay=false
            console.log(error);
          });
    },
    gosotorgaqr(){
      this.$router.push({name:"misqr"})
    },
    submit() {
      this.overlay = true;
      firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(data => {
            this.form.email = this.email;
            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
            this.compruebaemail(data.user);
          })
          .catch(err => {
            if(err.code === "auth/user-not-found"){
              firebase
                  .auth()
                  .createUserWithEmailAndPassword(this.email,this.password)
                  .then((userCredential) =>{
                    const user = userCredential.user;
                    this.form.email = this.email;
                    this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
                    this.compruebaemail(user)
                  })
              this.overlay = false;
            }else{
              this.error = "Puede haber un error con el email y/o password";
              this.overlay = false;
              this.alerterror = true;
            }
          });
    },
    formatDateee(value) {
      var fec = moment(value).locale('es-pe');

      return fec.tz(this.negocio.cliente.timeZone.timeZone).format("YYYY-MM-DD hh:mm:ss")
    },
    formatDatee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD")
    },
    formatfechanac(value) {
      return moment(value).locale('es-pe').format("DD-MM-YYYY")
    },
    registrar(user){
      this.form.uidFirebase = user.uid
      var bodyFormData = new FormData();
      this.form.createdAt = null
      this.form.fechaNacimiento = null
      this.overlay = true
      bodyFormData.append('data',JSON.stringify(this.form));
      axios.post("personas/registrar",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            store.dispatch("fetchUsuario", response.data.persona);
            store.dispatch("fetchTipoEntradas", tipoentrjson);
            store.dispatch("fetchTipoPagos", tipopagjson);
            store.dispatch("fetchTipoEventos", tipoevenjson);
            store.dispatch("fetchTipoMembresias", tipomembrjson);
            store.dispatch("fetchSexos", sexosjson);
            store.dispatch("fetchEstadoCarnets", estadocarjson);
            store.dispatch("fetchDias", diasjson);
            store.dispatch("conectarse")
            this.estaConectado();
            this.overlay = false;
          })

    },
    compruebaemail(user){
      var bodyFormData2 = new FormData();
      if(this.form.email !== ''){
      bodyFormData2.append("email",this.form.email)
      axios
          .post('personas/email',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            var person = response.data
            if (person.id == null){
              console.log("pasa registro")
              this.registrar(user)
            }else{
              console.log("comprueba email")
              if(person.uidFirebase === null) {
                this.editar(user,person.id)
              }else{
                if(person.uidFirebase !== user.uid ){
                  this.editar(user,person.id)
                }else{
                  this.logeo(user)
                }
              }
            }
          })
          .catch((error)  => {
            console.log(error);
          });}else{
        this.error = "Hubo un error con su Conexion";
        this.alerterrorregister = true;

      }
    },
    editar(user,id){
      this.form.uidFirebase = user.uid
      this.overlay = true
      var bodyFormData = new FormData();
      this.form.createdAt = this.formatDateee(new Date())
      this.form.fechaNacimiento = null
      bodyFormData.append('uidfirebase',this.form.uidFirebase);
      bodyFormData.append("personaId",id)
      axios.post("personas/editafb",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            console.log(response.data);
            this.logeo(user)
            this.overlay = false
          })
          .catch(error => {
            console.log(error)
            this.overlay = false
          });
    },
    register(){
        this.overlay = true;
        firebase
            .auth()
            .createUserWithEmailAndPassword(this.form.email,this.password2)
            .then((userCredential) =>{
              const user = userCredential.user
              this.compruebaemail(user)
              this.overlay = false
            })
            .catch(error => {
              if(error.code ==="auth/email-already-exists"){
                this.error = "Este email existe en Tunay se le esta enviando un mail automatico para cambiar de contraseña";
                firebase
                    .auth()
                    .sendPasswordResetEmail(this.form.email);

              }else{
                if(error.code === "auth/email-already-in-use"){
                  this.error = "Su Correo existe en nuestra base de datos de eventos con Google Mail o Apple Login por favor intente con Login con Google o Login con Apple, tambien puede que se le haya enviado un correo para que cambie el password";
                  firebase
                      .auth()
                      .sendPasswordResetEmail(this.form.email);
                  this.alerterror = true;
                }else{
                  this.error = "Hubo un error con su Conexion";

                }

              }
              this.overlay = false;
              this.alerterrorregister = true;
            });
    },
    logeo(user){
      var bodyFormData = new FormData();
      bodyFormData.append('uuid', user.uid);
      axios.post("personas/loginbyuid",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response => {
            store.dispatch("fetchUsuario", response.data.persona);
            store.dispatch("fetchClientes", response.data.clientes);
            store.dispatch("fetchCliente", response.data.clientes[0]);
            store.dispatch("fetchTipoEntradas", tipoentrjson);
            store.dispatch("fetchTipoPagos", tipopagjson);
            store.dispatch("fetchTipoEventos", tipoevenjson);
            store.dispatch("fetchTipoMembresias", tipomembrjson);
            store.dispatch("fetchSexos", sexosjson);
            store.dispatch("fetchEstadoCarnets", estadocarjson);
            store.dispatch("fetchDias", diasjson);
            store.dispatch("conectarse");
            this.overlay = false;
            this.estaConectado();
          })
          .catch(error => {
            this.registrar(user)
            this.overlay = false;

            console.log(error);
          });
    },
    codigoCanjeado() {
      this.valida = true
      this.usado = true
      this.existe = true
    },
    traeCodigo(){
      this.overlay = true
      axios
      .get('general/codigo/'+this.codigoUnico.trim())
          .then((response)  => {
            this.codigo = response.data;
            this.overlay = false;
            if(this.codigo.existe){
              this.elflyer = this.codigo.listaDetalleFiestaMaster.flyerActo
              if(this.codigo.personaDTO == null ){
                this.codigoExiste();
              }else{
                this.codigoCanjeado();
              }
            }else{
              this.codigoNoExiste();
            }
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false;
          });
    },
    codigoNoExiste(){
      this.existe = false
      this.valida = true
    },
    codigoExiste(){
      this.existe = true
      this.valida = true
      this.tipo = this.codigo.tipoLista
      if(this.conectado){
        this.estaConectado();
      }else{
        this.noConectado();
      }
    },
    estaConectado(){

        this.codigoFiesta();


    },
    codigoFiesta(){
      if(this.codigo.listaDetalleFiestaMaster.idPersona == null){
        this.noHayPersonaAsignadaFiesta()
      }else{
        this.gosotorgaqr();
      }
    },
    noHayPersonaAsignadaFiesta(){
      this.overlay = true
      var bodyFormData = new FormData();
      bodyFormData.append('codigo', this.codigoUnico.trim());
      bodyFormData.append('personaId', this.usuario.id);
      axios
          .post('general/codigo/fiesta',bodyFormData)
          .then((response)  => {
            this.codigo = response.data;
            this.overlay = false;
            this.gosotorgaqr();
          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false;
          });
    },
    noConectado(){

    },

    signingoogle(){
      var provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().languageCode = 'es'
      provider.setCustomParameters({
        'display': 'popup'
      });
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) =>{
            // var credential = result.credential;

            // The signed-in user info.
            var user = result.user;
            this.form.nombre = user.displayName
            this.form.email =  user.email
            this.form.foto =  user.photoURL

            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            // var accessToken = credential.accessToken;
            if(this.form.email ===''){
              this.error = "Tiene que compartir sus datos sino no es posible el registro.";
              this.overlay = false;
              this.alertloginerror = true;
            }else{
              this.compruebaemail(user)
            }
            // ...
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alertloginerror = true;
            // var errorMessage = error.message;
            // The email of the user's account used.
            // var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            console.log(errorCode)
            // ...
          });
    },
    signinemail(){
      this.normal=false;
      this.login = true;
    },
    registeremail(){
      this.normal = false;
      this.registro = true;
    },
    invitadoemail(){
      this.normal = false;
      this.invitado = true;
    },
    volver(){
      this.normal = true;
      this.login = false;
      this.registro = false;
      this.invitado = false;
    },
    signinapple(){
      var provider = new firebase.auth.OAuthProvider('apple.com')
      firebase.auth().languageCode = 'es'
      provider.setCustomParameters({
        'display': 'popup'
      });
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) =>{
            // var credential = result.credential;

            // The signed-in user info.
            var user = result.user;
            this.form.nombre = user.displayName
            this.form.email =  user.email
            this.form.foto =  user.photoURL

            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            // var accessToken = credential.accessToken;
            if(this.form.email ===''){
              this.error = "Tiene que compartir sus datos sino no es posible el registro.";
              this.overlay = false;
              this.alertloginerror = true;
            }else{
              this.compruebaemail(user)
            }

          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            // var errorMessage = error.message;
            // The email of the user's account used.
            // var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            console.log(errorCode)
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alertloginerror = true;
            // ...
          });
    },
    creategoogle(){
      var provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().languageCode = 'es'
      provider.setCustomParameters({
        'display': 'popup'
      });
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) =>{
            // var credential = result.credential;

            // The signed-in user info.
            var user = result.user;
            this.form.nombre = user.displayName
            this.form.email =  user.email
            this.form.foto =  user.photoURL
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            // var accessToken = credential.accessToken;
            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

            if(this.form.email ===''){
              this.error = "Tiene que compartir sus datos sino no es posible el registro.";
              this.overlay = false;
              this.alertloginerror = true;
            }else{
              this.compruebaemail(user)
            }
            // ...
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alertloginerror = true;
            // var errorMessage = error.message;
            // The email of the user's account used.
            // var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            console.log(errorCode)
            // ...
          });
    },
    createapple(){
      var provider = new firebase.auth.OAuthProvider('apple.com')
      firebase.auth().languageCode = 'es'
      provider.setCustomParameters({
        'display': 'popup'
      });
      firebase
          .auth()
          .signInWithPopup(provider)
          .then((result) =>{
            // var credential = result.credential;

            // The signed-in user info.
            var user = result.user;
            this.form.nombre = user.displayName
            this.form.email =  user.email
            this.form.foto =  user.photoURL
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            // var accessToken = credential.accessToken;
            this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

            if(this.form.email ===''){
              this.error = "Tiene que compartir sus datos sino no es posible el registro.";
              this.overlay = false;
              this.alertloginerror = true;
            }else{
              this.compruebaemail(user)
            }
            // ...
          })
          .catch((error) => {
            // Handle Errors here.
            var errorCode = error.code;
            // var errorMessage = error.message;
            // The email of the user's account used.
            // var email = error.email;
            // The firebase.auth.AuthCredential type that was used.
            // var credential = error.credential;
            console.log(errorCode)
            this.error = "Hubo un error con su Conexion";
            this.overlay = false;
            this.alertloginerror = true;
            // ...
          });
    },
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario",
      conectado: "conectado"
    })
  }
}
</script>
<style>
/* width */
::-webkit-scrollbar {
  width: 20px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: blue;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: darkblue;
}
</style>
